import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { PriceLimitCategory, SerialCreditApplicationRequest, SerialCreditApplicationResponse } from '../models/models'

export class CategoryPriceLimitApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/get-dealer-price-limits-category',
      requesterInfo,
    })
  }
  public async getLimits(): Promise<PriceLimitCategory[]> {
    return await this.getAsync<PriceLimitCategory[]>()
  }
}
